<template>
  <div>
    <!--xlsx表格导出-->
    <xlsx style="margin-bottom: 0.2rem;margin-top:0.2rem;" v-if="Permission.indexOf(107)!=-1"></xlsx>
<!--表格组件-->
    <TableComponent
      :Columns="Columns"
      :ColuumnsButton="ColuumnsButton"
      :data="list"
      :seek="seek"
      :RowKey="'deviceId'"
      :DeleteTitle="$t('lang.unusuallist.prompt')"
      @recoverfacility="recoverfacility"
      @sortChange="sortChange"
    >
    </TableComponent>
    <!--分页组件-->
    <pagination 
      :total="total" 
      :offset="offset" 
      :limit="limit" 
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>
  </div>
</template>

<script>
import {getUncertainDeviceList, recoverUncertainDevice,queryKeyword} from '@/api/unusuallist'
import pagination from '@/components/pagination'
import xlsx from '@/components/xlsx'
import { getPermission } from '../../../cookie/cookie';
import { PublicComponent } from '../../../mixins/common'
import TableComponent from '@/components/TableComponent/index'
import { Columns,ColuumnsButton } from "./TableConifg";

export default {
  mixins: [PublicComponent],
  data() {
    return {
      Permission:[],
      Columns:Columns,
      ColuumnsButton:ColuumnsButton,
      list: [],
      value4: '',
      seek:{
          deviceSn:'',
          deviceName:'',
          deviceSoftwareVer:'',
          deviceUpdate:''
      },
      sort:{
          deviceSn:null,
          deviceName:null,
          deviceSoftwareVer:null,
          deviceUpdate:null
      }
    }
  },
  components: {
    pagination,
    xlsx,
    TableComponent
  },
  mounted() {
    this.getUncertainDeviceList()
    this.Permission=getPermission()
  },
  methods: {
    //恢复设备
    recoverfacility(row) {
      this.$confirm(`${this.$t('lang.unusuallist.Tetx')}`, `${this.$t('lang.unusuallist.prompt')}`, {
        confirmButtonText: this.$t('lang.Button.confirm'),
        cancelButtonText: this.$t('lang.Button.cancel'),
        type: 'warning',
        center: true
      }).then(() => {
        recoverUncertainDevice(row.deviceId).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              message: this.$t('lang.unusuallist.success'),
              type: 'success'
            });
          }else {
            this.$message({
                message: this.$t('lang.unusuallist.RestoreMetaData'),
                type: 'warning'
            });
          }
          this.getUncertainDeviceList()
        })
      }).catch(() => {})
         
    },
    //获取异常设备列表
    getUncertainDeviceList() {
      getUncertainDeviceList().then((res) => {
        this.list = res.data.data.list
        this.list.unshift({})
        this.total=res.data.data.total
      })
    },
    //查询排序
    queryKeyword(){
      queryKeyword([this.seek.deviceSn,this.seek.deviceName,this.seek.deviceSoftwareVer,this.seek.deviceUpdate],
      this.offset,this.limit,this.sort).then((res)=>{
        this.list = res.data.data.list
        this.list.unshift({})
        this.total=res.data.data.total
      })
    },
    //表格排序
    sortChange(column) {
      //每次点击清空一次排序的赋值
      this.sort = {
        deviceSn:null,
        deviceName:null,
        deviceSoftwareVer:null,
        deviceUpdate:null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t('lang.unusuallist.Serial')) {
        this.sort.deviceSn = sortlist;
      } else if (label == this.$t('lang.unusuallist.DeviceName')) {
        this.sort.deviceName = sortlist;
      } else if (label == this.$t('lang.unusuallist.Version')) {
        this.sort.deviceSoftwareVer = sortlist;
      } else if (label == this.$t('lang.unusuallist.DeleteTime')) {
        this.sort.deviceUpdate = sortlist;
      }
    }
  }
}
</script>
<style scoped>
</style>
